import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { perfMarkEnd, perfMarkStart, perfTimeline } from '../utils/startupPerf';

/** Logs client-side route transition latency (no full reloads). */
export function useRoutePerf() {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const isFirstRef = useRef(true);

  useEffect(() => {
    if (isFirstRef.current) {
      isFirstRef.current = false;
      prevPathRef.current = location.pathname;
      return;
    }

    const from = prevPathRef.current;
    const to = location.pathname;
    if (from === to) return;

    perfMarkStart('route.change');
    perfTimeline('route.changeStart', 'navigation', { from, to });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        perfMarkEnd('route.change', 'navigation', { from, to });
        prevPathRef.current = to;
      });
    });
  }, [location.pathname]);
}
